export class MissingSessionError extends Error {
  constructor() {
    super("err-missing-session");
  }
}

export class InvalidSessionError extends Error {
  constructor() {
    super("err-invalid-session");
  }
}
